export default __webpack_public_path__ + "static/media/tab_10.9f608747.svg";